import { NgModule } from '@angular/core';
import { MatCommonModule, MatRippleModule } from '@angular/material/core';
import { MatRadioButtonComponent, MatRadioGroupDirective } from './radio.component';

@NgModule({
  imports: [MatRippleModule, MatCommonModule],
  exports: [MatRadioGroupDirective, MatRadioButtonComponent, MatCommonModule],
  declarations: [MatRadioGroupDirective, MatRadioButtonComponent],
})
export class RadioModule {}
